




import Vue from "vue";
import PersonnelChangeResult from "@/components/personnel-change/personnel-change-result.component.vue";
export default Vue.extend({
  components: {
    "personnel-change-result": PersonnelChangeResult
  }
});
